import { render, staticRenderFns } from "./DevolucionEmpaque.vue?vue&type=template&id=68d4a9d4&scoped=true"
import script from "./DevolucionEmpaque.vue?vue&type=script&lang=js"
export * from "./DevolucionEmpaque.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DevolucionEmpaque.vue?vue&type=style&index=1&id=68d4a9d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d4a9d4",
  null
  
)

export default component.exports